module.exports = __webpack_public_path__ + "img/1-2.1ce4e7f1.jpg";